"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useScrollToEnd;

var _react = require("react");

var _FunctionContext = _interopRequireDefault(require("../ScrollToBottom/FunctionContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useScrollToEnd() {
  var context = (0, _react.useContext)(_FunctionContext.default);
  return context.scrollToEnd;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTY3JvbGxUb0VuZC5qcyJdLCJuYW1lcyI6WyJ1c2VTY3JvbGxUb0VuZCIsImNvbnRleHQiLCJGdW5jdGlvbkNvbnRleHQiLCJzY3JvbGxUb0VuZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBOzs7O0FBRWUsU0FBU0EsY0FBVCxHQUEwQjtBQUN2QyxNQUFNQyxPQUFPLEdBQUcsdUJBQVdDLHdCQUFYLENBQWhCO0FBRUEsU0FBT0QsT0FBTyxDQUFDRSxXQUFmO0FBQ0QiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VDb250ZXh0IH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgRnVuY3Rpb25Db250ZXh0IGZyb20gJy4uL1Njcm9sbFRvQm90dG9tL0Z1bmN0aW9uQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVNjcm9sbFRvRW5kKCkge1xuICBjb25zdCBjb250ZXh0ID0gdXNlQ29udGV4dChGdW5jdGlvbkNvbnRleHQpO1xuXG4gIHJldHVybiBjb250ZXh0LnNjcm9sbFRvRW5kO1xufVxuIl19